// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */
import { loadMaps as LoadGoogleMap } from 'vendor/google/maps/googlemaps';

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// PAGE
/* load page specific scripts */
import { init as initOpeningHours } from './detail/opening-hours-exceptions';
import ImpressionSlider from './detail/impression-slider';

defaultBundle();
initOpeningHours();
LoadGoogleMap();
ImpressionSlider();
